import { z } from "zod";

/** R2 key of the desktop app manifest. The zip it points at lives under the same prefix. */
export const DESKTOP_MANIFEST_KEY = "downloads/desktop-latest.json";

const SHA256_HEX = /^[a-f0-9]{64}$/;
const SEMVER = /^\d+\.\d+\.\d+$/;
const DOWNLOAD_KEY = /^downloads\/[A-Za-z0-9._-]+\.zip$/;

/** The manifest written next to the desktop zip. Invalid manifests are treated as "not available". */
export const desktopManifestSchema = z.object({
  version: z.string().regex(SEMVER),
  key: z.string().regex(DOWNLOAD_KEY),
  size: z.number().int().positive(),
  sha256: z.string().regex(SHA256_HEX),
  builtAt: z.iso.datetime(),
  platforms: z.array(z.string().min(1)).min(1),
});

export type DesktopManifest = z.infer<typeof desktopManifestSchema>;

/** Public description of the desktop download, without the R2 key. */
export const desktopInfoSchema = desktopManifestSchema.pick({
  version: true,
  size: true,
  sha256: true,
  builtAt: true,
  platforms: true,
});

export type DesktopInfo = z.infer<typeof desktopInfoSchema>;

/** R2 key of the release index: every published desktop zip, newest first. Not served publicly. */
export const RELEASES_INDEX_KEY = "downloads/releases.json";

/** One published desktop release. Same fields as the manifest, which is the newest entry. */
export const releaseEntrySchema = desktopManifestSchema;

export type ReleaseEntry = z.infer<typeof releaseEntrySchema>;

/** downloads/releases.json, written by scripts/release-desktop.mjs. Newest first. */
export const releasesIndexSchema = z.object({
  releases: z.array(releaseEntrySchema),
});

export type ReleasesIndex = z.infer<typeof releasesIndexSchema>;
